import $ from "jquery";
import JustValidate from 'just-validate';
import Cookies from "js-cookie";

const handler = ( $ ) => {

	const $loginForm = $('#main-login-form'),
	$forgotPassForm = $('#main-forgot-password-form'),
	$forgotPassThankYouMessage = $('#main-forgot-password-thank-you');

	/**
	 * Switch to Forgot Password Form
	 */
	$('#forgot-password-link').on( 'click', function( e ) {
		e.preventDefault();

		// hide all forms
		$('.login-form').hide();

		// display Forgot Password Form
		$forgotPassForm.slideDown('fast', function() {
			$('#recover-email').focus();
		});

	});

	/**
	 * Switch to Login Form
	 */
	$('.back-to-login').on( 'click', function( e ) {
		e.preventDefault();

		// hide all forms
		$('.login-form').hide();

		// display login form
		$loginForm.slideDown('fast', function() {
			$('#login-email').focus();
		});

	});

	$('#main-login-form, #main-forgot-password-form, #main-change-password-form').each( function( e ) {

		const $form = $(this),
		formType = $form.data('validate'),
		formAction = $form.find('input[name=action]').val(),
		$resultDiv = $form.find('.result'),
		$submit = $form.find( 'button[type=submit]');

		$form.find( '[name=return_url]').val( window.location.href );

		const validator = new JustValidate( $form[0], {
			validateBeforeSubmitting: true,
		});

		const strongPasswordRegexp = /^(?=.*[0-9])(?=.*[!"#$%&'()*+,-.\/:;<=>?@[\\\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,-.\/:;<=>?@[\\\]^_`{|}~*]{8,}$/,
		strongPasswordErrorText = 'Password should contain minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character';

		switch( formType ) {

			case 'form-login':

				validator.addField( '#login-email', [
					{ rule: 'required' },
					{ rule: 'email' }
				]).addField( '#login-password', [
					{ rule: 'required' }
				]);

			break;

			case 'form-forgot-password':

				validator.addField( '#recover-email', [
					{ rule: 'required' },
					{ rule: 'email' }
				]);

			break;

			case 'form-change-password':

				validator.addField( '#new-password', [
					{ rule: 'customRegexp', value: strongPasswordRegexp, errorMessage: strongPasswordErrorText },
					{ rule: 'required' }
				]).addField( '#new-password2', [
					{ rule: 'customRegexp', value: strongPasswordRegexp, errorMessage: strongPasswordErrorText },
					{ rule: 'required' }
				]);

			break;

		}

		validator.onFail(( fields ) => {

			for( let i in fields) {
				if( fields[i].isValid ) {
					$(fields[i].elem).parents('.form-row').removeClass('is-error');
				} else {
					$(fields[i].elem).parents('.form-row').addClass('is-error');
				}
				
			}

		});

		validator.onSuccess(( event ) => {

			$form.find('.form-row').removeClass('is-error');

			$.ajax({
				url: themeVars.ajaxurl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: formAction,
					nonce: Cookies.get('wordpress_pen_ajax_nonce'),
					data: $form.serialize()
				},
				beforeSend: function() {

					$submit.attr('disabled', 'disabled');
					$form.addClass( 'is-loading');
					$resultDiv.html('');

				},
				success: function( answer ) {

					$submit.removeAttr('disabled');
					$form.removeClass( 'is-loading');

					if( answer.success == true && answer.data && answer.data.refresh ) {

						window.location.reload();

					} else if( answer.success == false ) {

						$resultDiv.html( '<div class="error">' + answer.data.message + '</div>');

					} else if( answer.success == true ) {

						switch( formType ) {

							case 'form-forgot-password':
								$forgotPassForm.hide();
								$forgotPassThankYouMessage.slideDown('fast');
							break;

						}

					}

				}
			});

		});

	});


};

export default ( ( $ ) => $( handler ) )( jQuery );
